enum EPermissionTypes {
  AllInterventions = 'all_interventions',
  CompanyDetails = 'company_details',
  InvoicePermission = 'invoice_permission',
  UserManagement = 'user_management',
}

export default EPermissionTypes;
